import InstanceService from './instance.service'

const useInstanceService = () => {
  const instanceService = new InstanceService()
  return instanceService
}

export default useInstanceService
